import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import UserList from './UserList';
import PlanControls from './PlanControls';
import LogViewer from './LogViewer';
import WAFLogViewer from './WAFLogViewer';
import ProjectTracker from './ProjectTracker';
import ArchiveMetrics from './ArchiveMetrics';
import EmailAlerts from './EmailAlerts';

const DashboardLayout = ({ user, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  return (
    <Router>
      <div style={{ display: 'flex', height: '100vh' }}>
        {/* Menu Toggle Button */}
        <button
          onClick={toggleSidebar}
          style={{
            position: 'fixed',
            top: '20px',
            left: sidebarOpen ? '240px' : '20px',
            zIndex: 1000,
            background: '#2c3e50',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            padding: '8px 12px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
          }}
        >
          <span style={{ fontSize: '18px' }}>☰</span>
          <span style={{ fontSize: '14px' }}>Menu</span>
        </button>

        {/* Blue Sidebar - STYLING UPDATED ONLY */}
        <aside style={{
          width: '220px',
          background: 'linear-gradient(180deg, #2c3e50 0%, #34495e 100%)',
          color: 'white',
          padding: '20px',
          boxShadow: '2px 0 5px rgba(0,0,0,0.1)',
          position: 'fixed',
          height: '100vh',
          left: sidebarOpen ? '0' : '-220px',
          transition: 'left 0.3s ease',
          zIndex: 999
        }}>
          <h2 style={{
            fontSize: '20px',
            marginBottom: '20px',
            color: 'white',
            textAlign: 'center'
          }}>
            WedArchive Admin
          </h2>
          <nav>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li style={{ marginBottom: '12px' }}>
                <Link
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    display: 'block',
                    padding: '10px 15px',
                    borderRadius: '6px',
                    transition: 'background-color 0.2s'
                  }}
                  to="/users"
                  onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  👥 Users
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    display: 'block',
                    padding: '10px 15px',
                    borderRadius: '6px',
                    transition: 'background-color 0.2s'
                  }}
                  to="/plan-controls"
                  onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  ⚙️ Plan Controls
                </Link>
              </li>
              <li>
                <Link
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    display: 'block',
                    padding: '10px 15px',
                    borderRadius: '6px',
                    transition: 'background-color 0.2s'
                  }}
                  to="/email-alerts"
                  onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  📧 Email Alerts
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    display: 'block',
                    padding: '10px 15px',
                    borderRadius: '6px',
                    transition: 'background-color 0.2s'
                  }}
                  to="/project-tracker"
                  onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  📊 Project Tracker
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    display: 'block',
                    padding: '10px 15px',
                    borderRadius: '6px',
                    transition: 'background-color 0.2s'
                  }}
                  to="/metrics"
                  onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  📈 Archive Metrics
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <details style={{ color: 'white' }}>
                  <summary style={{
                    cursor: 'pointer',
                    color: 'white',
                    padding: '10px 15px',
                    borderRadius: '6px',
                    listStyle: 'none'
                  }}>
                    📋 Logs
                  </summary>
                  <ul style={{ listStyle: 'none', paddingLeft: '1em', marginTop: '8px' }}>
                    <li style={{ marginBottom: '6px' }}>
                      <Link
                        style={{
                          color: '#bdc3c7',
                          textDecoration: 'none',
                          display: 'block',
                          padding: '8px 15px',
                          borderRadius: '6px',
                          fontSize: '14px'
                        }}
                        to="/logs"
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
                          e.target.style.color = 'white';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = 'transparent';
                          e.target.style.color = '#bdc3c7';
                        }}
                      >
                        Admin Actions
                      </Link>
                    </li>
                    <li style={{ marginBottom: '6px' }}>
                      <Link
                        style={{
                          color: '#bdc3c7',
                          textDecoration: 'none',
                          display: 'block',
                          padding: '8px 15px',
                          borderRadius: '6px',
                          fontSize: '14px'
                        }}
                        to="/waf-logs"
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
                          e.target.style.color = 'white';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = 'transparent';
                          e.target.style.color = '#bdc3c7';
                        }}
                      >
                        🛡️ WAF Logs
                      </Link>
                    </li>
                    <li style={{ color: '#aaa', fontSize: '0.9em', padding: '4px 15px' }}>
                      (Future logs)
                    </li>
                  </ul>
                </details>
              </li>
            </ul>
          </nav>

          {/* User info at bottom of sidebar */}
          <div style={{
            position: 'absolute',
            bottom: '20px',
            left: '20px',
            right: '20px',
            borderTop: '1px solid rgba(255,255,255,0.2)',
            paddingTop: '20px'
          }}>
            <div style={{
              color: '#bdc3c7',
              fontSize: '12px',
              marginBottom: '10px'
            }}>
              Signed in as:
              <div style={{
                color: 'white',
                fontSize: '14px',
                marginTop: '4px',
                wordBreak: 'break-word'
              }}>
                {user.attributes?.email || user.username}
              </div>
            </div>
            <button
              className="btn btn-sm btn-outline-light"
              onClick={onLogout}
              style={{
                width: '100%',
                borderColor: 'rgba(255,255,255,0.5)',
                color: 'white'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              Sign Out
            </button>
          </div>
        </aside>

        {/* Main Content - STYLING UPDATED ONLY */}
        <main style={{
          flex: 1,
          padding: '20px',
          backgroundColor: '#f8f9fa',
          minHeight: '100vh',
          marginLeft: sidebarOpen ? '220px' : '0',
          transition: 'margin-left 0.3s ease',
          width: '100%'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            minHeight: 'calc(100vh - 40px)',
            padding: '20px'
          }}>
            <Routes>
              <Route path="/users" element={<UserList user={user} />} />
              <Route path="/plan-controls" element={<PlanControls user={user} />} />
              <Route path="/" element={<UserList user={user} />} />
              <Route path="/logs" element={<LogViewer user={user} />} />
              <Route path="/waf-logs" element={<WAFLogViewer user={user} />} />
              <Route path="/project-tracker" element={<ProjectTracker user={user} />} />
              <Route path="/metrics" element={<ArchiveMetrics />} />
              <Route path="/email-alerts" element={<EmailAlerts user={user} />} />
            </Routes>
          </div>
        </main>
      </div>
    </Router>
  );
};

export default DashboardLayout;
